
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import * as AppConstant from '../common/AppConstant'


class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        console.log(props)
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            username: "",
            emailPrimary: "",
            apiStatus: {
                isError: true,
                message: ''
            }
        };
    }

    handleFormSubmit() {
        let body = {
            username: this.state.username,
            emailPrimary: this.state.emailPrimary
        };
        const {apiStatus}  = this.state;
        apiStatus.isError = false;
        apiStatus.message = ""
        this.setState({apiStatus:apiStatus})

        if(AppConstant.validateValue( this.state.username,"S") === false
            && AppConstant.validateValue( this.state.emailPrimary,"S") === false){
            const {apiStatus}  = this.state;
            apiStatus.isError = true;
            apiStatus.message = "Enter Email or Username"
            this.setState({apiStatus:apiStatus})
            return
        }
        fetch(this.props.api + '/login/forgotPassword', {
            body: JSON.stringify(body),
            method: "POST",
            mode: 'cors',
            headers: {'content-type': 'application/json'}
        })
        .then(response => response.json())
        .then(json => {
                console.log(json);
                const {apiStatus}  = this.state;
                if (json && json.isError === false) {
                    apiStatus.isError = false;
                    apiStatus.message = json.message
                } else {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = json.message
                }
                this.setState({apiStatus:apiStatus})
        })
        .catch(error => console.error(error));
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    render() {
        let _this = this;
        return (
            <div className="passwordBox animated fadeInDown">
                <div className="row">

                    <div className="col-md-12">
                        <div className="ibox-content">

                            <h2 className="font-bold">{_this.props.msg('forgotPassword.password')}</h2>
                                             <span style={{'color':this.state.apiStatus.isError===true?'red':'green'}}>
                                                            {this.state.apiStatus.message ? this.state.apiStatus.message : ''}
                                             </span>
                            <br/>
                            <p>
                                {_this.props.msg('forgotPassword.emailAndUsernameNote')}
                            </p>

                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Email address"
                                               name='emailPrimary' id='emailPrimary'
                                               value={this.state.emailPrimary}
                                               onChange={this.handleChange}/>
                                    </div>

                                    OR

                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="username"
                                        name='username'  id='username'
                                        value={this.state.username}
                                        onChange={this.handleChange}/>
                                    </div>
                                    <a onClick={this.handleFormSubmit} className="btn btn-primary block full-width m-b">{_this.props.msg('forgotPassword.send')}</a>
                                    <Link className="btn btn-primary block full-width m-b" to="/login">{_this.props.msg('forgotPassword.goToLogin')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/security/ForgotPassword.js